import createIcon from '../../createIcon';

/**
 * @component @name FormatSize
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC41IDQuNVY3LjVIMTMuNVYxOS41SDE2LjVWNy41SDIxLjVWNC41SDguNVpNMi41IDEyLjVINS41VjE5LjVIOC41VjEyLjVIMTEuNVY5LjVIMi41VjEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatSize = createIcon('FormatSize', [
  [
    'path',
    {
      d: 'M8.5 4.5V7.5H13.5V19.5H16.5V7.5H21.5V4.5H8.5ZM2.5 12.5H5.5V19.5H8.5V12.5H11.5V9.5H2.5V12.5Z',
      key: '1t6git',
    },
  ],
]);

export default FormatSize;
